import * as angular from 'angular';
import {StateProvider} from '@uirouter/angularjs';

import CreateCaseController from "./createController";

class Routes {
    static $inject = ['$stateProvider'];

    constructor($stateProvider: StateProvider) {
        $stateProvider
            .state('case', {
                abstract: true,
                url: '/case'
            })

            .state('case.create', {
                url: '/create',
                template: require('./create.html'),
                controller: CreateCaseController,
                controllerAs: 'vm',
                data: {title: 'Create Case'}
            })

    }
}

export default angular.module('app.case', [])
    .config(Routes)
    .name;
